export default Object.freeze({
  PROJECT_LOAD: 'PROJECT_LOAD',
});
